import { useLocation } from 'react-router-dom';
import { useMemo } from 'react'; 
import { userFieldConfig } from '../pages/users/user.config';
import { useUserFormOptions } from '../hooks/useFormOptions';
import { roleFieldConfig } from '../pages/roles/role.config';
import ExcelUploadManager from './excelUpload/ExcelUploadManager';
import { FormFieldConfig } from '../types/formField.types';
import { FieldOption } from '../utils/options';
import { roleApi, userApi } from '../api/accountsApi';
 
interface ModuleConfig {
  fieldConfig: FormFieldConfig[];
  formOptionsHook?: () => Record<string, FieldOption[]>;
  title: string;
  saveApi: any;
}

const AccountsExcelUpload = () => {
  const location = useLocation();
  const moduleName = location.pathname.split('/')[1]; // e.g. 'users', 'roles'

  const { fieldConfig, formOptionsHook, title, saveApi }: ModuleConfig = useMemo(() => {
    switch (moduleName) {
      case 'users':
        return {
          fieldConfig: userFieldConfig,
          formOptionsHook: useUserFormOptions,
          title: 'Users',
          saveApi: userApi.batchCreate,
        };
      case 'roles':
        return {
          fieldConfig: roleFieldConfig,
          formOptionsHook: undefined,
          title: 'Roles',
          saveApi: roleApi.batchCreate,
        };
      default:
        return {
          fieldConfig: [],
          formOptionsHook: () => ({}),
          title: '📊 Upload Excel File',
          saveApi: async () => ({ failedRows: [] }), // no-op
        };
    }
  }, [moduleName]);

  const formOptions: Record<string, FieldOption[]> = formOptionsHook ? formOptionsHook() : {};

  const mappedFields = useMemo(() => {
    return fieldConfig.map((field: FormFieldConfig) =>
      formOptions[field.name] ? { ...field, options: formOptions[field.name] } : field
    );
  }, [fieldConfig, formOptions]);

  return (
    <ExcelUploadManager
      moduleTitle={title}
      fieldConfig={mappedFields}
      saveApi={saveApi}
    />
  );
};

export default AccountsExcelUpload;
